const VITE_SITE_URL = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env && (import.meta as Record<string, Record<string, string>>).env.VITE_SITE_URL) || '';

export const SITE_URL = VITE_SITE_URL || 'https://vigorbuyspread.lol';